/* eslint-disable indent */
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    @media print {
        .container-fluid, .navbar,
        #flash-messages, #wrap-left-aside, #product-menu, #side-menu, #bxS-ml, #eml-read__toolbar,
        footer { display: none; }
    }
`;
